export default "__VITE_ASSET__Dolx6vQt__"